/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

/** @see backend/nexus/modules/Billing/Enum/PlanInterval.php */
export const planInterval = {
	monthly: 'monthly',
	yearly: 'yearly',
} as const

/** @see backend/nexus/modules/Billing/Enum/PlanInterval.php */
export type PlanInterval = (typeof planInterval)[keyof typeof planInterval]
